<template>
    <!--General Settings, Service Hours main container-->
    <div class="general-settings">
        <!--Main container for General Settings-->
        <div class="main-container-work-settings">
            <div class="heading-container">
                <!--Title-->
                <div>
                    <h3>{{ $t("schedule.general") }}</h3>
                </div>
                <!--Team select-->
                <div v-if="
                    adminDetails.group_owner == 1 &&
                    adminDetails.group_active == 1 && !loading
                " class="select-input-wrap">
                    <label class="stylist-label" for="stylist-select"
                        :class="generalOptions.app_id === 5 ? 'loctician' : ''">Select
                        {{
                            generalOptions.app_id === 1
                                ? "Stylist"
                                : generalOptions.app_id === 2
                                    ? "Barber"
                                    : generalOptions.app_id === 5
                                        ? "Loctician"
                                        : ""
                        }}</label>
                    <select id="stylist-select" v-model="for_stylist_id" v-on:change="onStylistChange"
                        class="selectInput selectInputSmall">
                        <option v-for="(member, index) in groupMembers" v-bind:key="index" v-bind:value="member.user.id"
                            v-bind:disabled="member.active != 1">
                            {{ member.user.first_name }} {{ member.user.last_name }}
                        </option>
                    </select>
                </div>
            </div>
            <!--General Settings main content-->
            <div class="content-work-settings section-wrap" v-if="!loading">
                <!--General Settings wrapper-->
                <div class="work-settings-wrap">
                    <!--Row wrapper for Pause between appointments and time slot booking -->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <!--Pause between appointments-->
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.pause") }}</span>
                            <div class="input-wrap">
                                <label class="radio-label">
                                    <input class="text-field text-field-small" type="number" min="0" value="0"
                                        oninput="validity.valid||(value='');"
                                        v-model="work_settings.pause_between_appointments" />
                                </label>
                                <span class="">{{ $t("general.min") }}</span>
                            </div>
                        </div>
                        <!--time slot booking-->
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.timeSlot") }}</span>

                            <div class="input-wrap">
                                <label class="radio-label">
                                    <input class="text-field text-field-small" v-model.number="timeSlotBooking"
                                        placeholder="Add Time" type="number" />
                                </label>
                                <span>{{ $t("general.min") }}</span>
                            </div>
                        </div>
                    </div>
                    <!--BLOCK OUT (vacation days or time off)-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.blockOut") }}</span>

                            <div class="input-wrap">
                                <div class="link">
                                    <router-link :to="{ path: '/app/block-out' }">{{
                                        $t("schedule.blockOutUrl")
                                        }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Guests allowed to book-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.guests") }}</span>
                            <div class="input-wrap">
                                <div class="radio-label">
                                    <input type="number" min="0" class="text-field text-field-small"
                                        v-model="work_settings.hours_limit" />
                                    <span>{{ $t("schedule.hoursAdvance") }}</span>
                                </div>
                                <div>
                                    <label class="switch">
                                        <input type="checkbox" v-model="work_settings.hours_limit_active"
                                            :true-value="1" :false-value="0" />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="input-wrap">
                                <div class="radio-label">
                                    <input type="number" min="0" class="text-field text-field-small"
                                        v-model="work_settings.available_future_days" />
                                    <span>{{ $t("schedule.daysInFuture") }}</span>
                                </div>
                            </div>
                            <div class="input-wrap">
                                <div class="settings-field-note">
                                    <i>{{ $t("schedule.daysInFutureNote") }}</i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Prevent clients from booking-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.preventClients") }} </span>

                            <div class="input-wrap">
                                <div class="radio-label">
                                    <span>
                                        {{ $t("schedule.preventClientsText") }}
                                        <strong>{{ $t("general.yes") }}.</strong>
                                        <br />
                                        {{ $t("schedule.otherwise") }}
                                        <strong>{{ $t("general.no") }}.</strong>
                                    </span>
                                </div>
                                <select v-model="work_settings.prevent_clients_book"
                                    class="selectInput selectInputExtraSmall">
                                    <option :value="true">{{ $t("general.yes") }}</option>
                                    <option :value="false">{{ $t("general.no") }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--Prevent clients to reschedule-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">
                                {{ $t("schedule.preventClientsReschedule") }}</span>
                            <div class="input-wrap">
                                <div class="radio-label">
                                    <span>
                                        {{ $t("schedule.preventClientsRescheduleText") }}
                                        <strong>{{ $t("general.yes") }}.</strong>
                                        <br />
                                        {{ $t("schedule.otherwise") }}
                                        <strong>{{ $t("general.no") }}.</strong>
                                    </span>
                                </div>
                                <select v-model="work_settings.prevent_clients_reschedule"
                                    class="selectInput selectInputExtraSmall">
                                    <option :value="true">{{ $t("general.yes") }}</option>
                                    <option :value="false">{{ $t("general.no") }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--Accept new clients-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.acceptNewClients") }}</span>
                            <div class="input-wrap">
                                <div class="radio-label">
                                    <span>
                                        {{ $t("schedule.acceptNewClientsText") }}
                                        <strong>{{ $t("general.yes") }}</strong>.
                                        <br />
                                        {{ $t("schedule.otherwise") }}
                                        <strong>{{ $t("general.no") }}</strong>, {{
                                            $t("schedule.acceptNewClientsText2") }}.
                                    </span>
                                </div>
                                <select v-model="work_settings.accept_new_clients"
                                    class="selectInput selectInputExtraSmall">
                                    <option :value="true">{{ $t("general.yes") }}</option>
                                    <option :value="false">{{ $t("general.no") }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row-section section-wrap" v-if="!work_settings.accept_new_clients">
                            <div class="input-wrap">
                                <div>
                                    {{ $t("schedule.acceptNewClientsOffText1") }}
                                    <strong>{{ $t("schedule.acceptNewClientsOffText2") }}</strong>
                                    {{ $t("schedule.acceptNewClientsOffText3") }}
                                </div>
                            </div>
                            <div class="input-wrap">
                                <div class="textarea-wrap">
                                    <textarea class="text-field new-clients-message"
                                        :placeholder="$t('schedule.acceptNewClientsOffMessage')" :maxlength="120"
                                        v-on:keyup="countChar('accept_new_clients_text')"
                                        v-model="work_settings.accept_new_clients_text"></textarea>
                                    <div class="small text-secondary align-self-end">
                                        <span>{{ counter.accept_new_clients_text }}/120 char.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="input-wrap">
                                <div class="link">
                                    <a :href="portfolio_url" target="_blank">
                                        {{ $t("schedule.acceptNewClientsOffLinkText") }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Confirm Appointments-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.confirmAppt") }}</span>

                            <div class="input-wrap">
                                <div class="radio-label">
                                    <span>
                                        {{ $t("schedule.confirmApptText") }}
                                        <strong>{{ $t("general.yes") }}.</strong>
                                        <br />
                                        {{ $t("schedule.confirmApptTex2") }}
                                        <strong>{{ $t("general.no") }}.</strong>
                                    </span>
                                </div>
                                <select v-model="settings.auto_confirm_appointments"
                                    class="selectInput selectInputExtraSmall">
                                    <option :value="true">{{ $t("general.yes") }}</option>
                                    <option :value="false">{{ $t("general.no") }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--NOTIFY CLIENTS-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.notifyClients") }}</span>

                            <div class="input-wrap">
                                <router-link class="link" :to="{ path: '/app/work-settings/notifications' }">{{
                                    $t("schedule.notificationsUrl")
                                    }}</router-link>
                            </div>
                        </div>
                        <span class="section-note">{{ $t("schedule.notifyClientsInviteText") }}</span>
                        <div class="row-section">
                            <div class="input-wrap">
                                <div class="radio-label">
                                    {{ $t("schedule.notifyInvite") }}
                                </div>
                                <select v-model="notification_settings.invite"
                                    class="selectInput selectInputExtraSmall">
                                    <option :value="true">{{ $t("general.yes") }}</option>
                                    <option :value="false">{{ $t("general.no") }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--Enable Online Booking from Portfolio page-->
                    <div class="row-section-wrap highlighted-box section-wrap">
                        <div class="row-section">
                            <span class="section-headline-work">{{ $t("schedule.onlineBooking") }}</span>
                            <div class="input-wrap">
                                <div class="radio-label">
                                    {{ $t("schedule.onlineBookingYes") }}
                                </div>
                                <select v-model="settings.accept_website_booking"
                                    class="selectInput selectInputExtraSmall">
                                    <option :value="true">{{ $t("general.yes") }}</option>
                                    <option :value="false">{{ $t("general.no") }}</option>
                                </select>
                            </div>
                            <div class="input-wrap">
                                <div class="radio-label">
                                    <div class="link">
                                        <a :href="portfolio_url" target="_blank">
                                            {{ $t("schedule.porfolioPage") }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Save button for General-->
                    <div class="save-work-setting-btn">
                        <div>
                            <button class="primary-btn extra-small" v-on:click="saveWorkSettings">
                                {{ $t("general.save") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <MainLoader class="section-wrap" v-if="loading" />
        </div>
    </div>
</template>

<script>
import auth from "./../../services/auth.js";
import api from "../../services/apiEndpoints.js";
import store from "./../../services/vuex.js";
import messages from "./../../services/messages.js";
import eventBus from "../../services/eventBus.js";
import MainLoader from "./general-components/MainLoader.vue";

export default {
    name: "GeneralSettings",

    data: function () {
        return {
            work_settings: {},
            for_stylist_id: 0,
            settings: {},
            notification_settings: {},
            portfolio_url: "",
            timeSlotBooking: "",
            counter: {
                accept_new_clients_text: 0,
            },
            loading: false,
        };
    },
    mounted: function () {
        this.for_stylist_id = auth.state.user.id;
        this.getWorkSettings();

        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });
    },
    beforeDestroy() {
        eventBus.off("admin_details_loaded");
    },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
        groupMembers: {
            get: function () {
                return store.state.stylists;
            },
            set: function (value) {
                store.commit("setStylists", value);
            },
        },
    },
    watch: {
        'work_settings.hours_limit'(value) {
            if (value != null) {
                this.work_settings.hours_limit = String(value)
                    .replace(/\D/g, '')
                    .slice(0, 2);
            }
        },

        'work_settings.available_future_days'(value) {
            if (value != null) {
                this.work_settings.available_future_days = String(value)
                    .replace(/\D/g, '')
                    .slice(0, 3);
            }
        }
    },
    methods: {
        onAdminDetailsLoad: function () {
            if (this.adminDetails.group_id && this.adminDetails.group_owner) {
                this.getGroupsMembers(this.adminDetails.group_id);
            }
        },
        getGroupsMembers: function (group_id) {
            this.serviceCategories = [];
            this.services = {};

            this.$http.get(api.actions.get_stylist_group_members + group_id).then(
                function (response) {
                    if (typeof response.data.members != "undefined") {
                        this.groupMembers = response.data.members;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        getWorkSettings: function () {
            this.loading = true;
            let stylist_id = this.for_stylist_id != auth.state.user.id ? "?user_id=" + this.for_stylist_id : "";

            let getAllSettings = "getAllSettings=1";
            if (stylist_id != "") {
                getAllSettings = "&" + getAllSettings;
            } else {
                getAllSettings = "?" + getAllSettings;
            }

            this.$http.get(api.actions.get_work_settings + stylist_id + getAllSettings).then(
                function (response) {
                    this.loading = false;

                    if (typeof response.data.work_settings != "undefined") {
                        this.adminDetails.work_settings = response.data.work_settings;
                        this.work_settings = response.data.work_settings;
                        this.work_settings_clone = Object.assign({}, this.work_settings);
                        this.work_settings.accept_new_clients = Boolean(this.work_settings.accept_new_clients);
                        this.work_settings.prevent_clients_reschedule = !Boolean(
                            this.work_settings.prevent_clients_reschedule
                        );
                        this.work_settings.prevent_clients_book = !Boolean(this.work_settings.prevent_clients_book);
                        this.settings = response.data.settings;
                        this.settings.auto_confirm_appointments = Boolean(this.settings.auto_confirm_appointments);
                        this.settings.accept_website_booking = Boolean(this.settings.accept_website_booking);
                        this.portfolio_url = response.data.portfolio_url;
                        this.timeSlotBooking = response.data.settings.default_slot_time;
                        this.notification_settings = response.data.notification_settings;
                        this.notification_settings.invite = Boolean(this.notification_settings.invite);
                    }
                    this.loading = false;
                }.bind(this)
            );
        },

        saveWorkSettings: function () {
            if (this.problemsInHours) {
                this.problemsInHours = false;
                return;
            }

            if (this.for_stylist_id != auth.state.user.id) {
                this.work_settings.group_user_id = this.for_stylist_id;
            }
            //add accept_website_booking
            this.work_settings.accept_website_booking = this.settings.accept_website_booking ? 1 : 0;

            //add default_slot_time
            this.work_settings.default_slot_time = this.timeSlotBooking;

            //auto_confirm_appointments
            this.work_settings.auto_confirm_appointments = this.settings.auto_confirm_appointments;

            //notification settings
            this.work_settings.notification_schedule = this.notification_settings.schedule;
            this.work_settings.notification_reschedule = this.notification_settings.reschedule;
            this.work_settings.notification_cancel = this.notification_settings.cancel;
            this.work_settings.notification_invite = this.notification_settings.invite;

            this.work_settings.prevent_clients_book = !this.work_settings.prevent_clients_book;
            this.work_settings.prevent_clients_reschedule = !this.work_settings.prevent_clients_reschedule;

            this.loading = true;
            this.$http.post(api.actions.save_work_settings, this.work_settings).then(
                function (response) {
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);

                        this.getWorkSettings();
                    }
                }.bind(this)
            );
        },
        onStylistChange() {
            this.getWorkSettings();
        },
        countChar: function (type) {
            this.counter[type] = this.work_settings[type].length;
        },
    },
    components: {
        MainLoader,
    },
};
</script>